import { useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

const useClientHeight = () => {
    const [clientHeight, setClientHeight] = useState('100vh');

    const resizeHandler = () => {
        const newClientHeight = `${document.documentElement.clientHeight}px`;
        if (newClientHeight !== clientHeight) {
            setClientHeight(newClientHeight);
        }
    };

    const debounceResizeHandler = debounce(resizeHandler, 250);

    useEffect(() => {
        resizeHandler();

        window.addEventListener('resize', debounceResizeHandler);
        return () => {
            window.removeEventListener('resize', debounceResizeHandler);
        };
    }, [clientHeight]);

    return clientHeight;
};

export default useClientHeight;
